/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/
import ScrollDir from "scrolldir";
import ScrollLocker from '../classes/scroll-locker';
import ScrollController from '../classes/scroll-controller';
/*------------------------------------------------------------------
Scroll Direction
------------------------------------------------------------------*/

ScrollDir(); // /*------------------------------------------------------------------
// Scroll Controller
// ------------------------------------------------------------------*/

window.ScrollLocker = new ScrollLocker(document.querySelector('.body'));
window.ScrollController = new ScrollController();